import styled from 'styled-components';

import getColor, { ColorName } from 'happytree';

import Icon from '../../../Icon';
import ButtonBase from '../ButtonBase';
import { ButtonSize } from './Button';

export const disabledStyles = `
  background-color: ${getColor('neutral', 2)};
  color: ${getColor('neutral')};
  pointer-events: none;
`;

export const Button = styled(ButtonBase)<{
  buttonSize: ButtonSize;
  buttonColor: ColorName;
  isSelected: boolean;
}>`
  border-radius: 8px;
  color: ${getColor('background')};
  padding: 0 24px;
  font-size: 14px;

  &:focus {
    &::after {
      border-radius: 8px;
    }
  }

  ${({ buttonSize }) => `
    height: ${buttonSize};

    ${
      buttonSize === ButtonSize.Size24
        ? `
          border-radius: 4px; 
          font-size: 12px; 
          padding: 0 8px;

          &:focus {
            &::after {
              border-radius: 4px;
            }
          }
          `
        : ''
    }

    ${buttonSize === ButtonSize.Size32 ? 'padding: 0 16px;' : ''}
  `}

  ${({ buttonColor, isSelected }) => `
    background-color: ${
      isSelected ? getColor(buttonColor, -2) : getColor(buttonColor)
    };

    &:focus {
      &::after {
        border-color: ${getColor(buttonColor, -2)};
      }
    }
  `}

  ${({ isDisabled }) => isDisabled && disabledStyles}
`;

export const LoadingIcon = styled(Icon)<{ isVisible: boolean }>`
  position: absolute;
  ${({ isVisible }) => (isVisible ? 'display: block;' : 'display: none')};
`;

export const ButtonContent = styled.span<{ isVisible: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  visibility: hidden;
  width: 100%;
  height: 100%;
  line-height: 12px;
  ${({ isVisible }) => (isVisible ? 'visibility: visible;' : '')};
`;
